import {PlusOutlined} from '@ant-design/icons';
import {Upload} from 'antd';
import {UploadFile} from 'antd/es/upload/interface';
import cn from 'classnames';
import React, {CSSProperties, FC} from 'react';

import {ReactComponent as CloseIcon} from 'shared/assets/forms/delete-x.svg';
import {ReactComponent as FileIcon} from 'shared/assets/forms/file.svg';
import {ReactComponent as LinkIcon} from 'shared/assets/link.svg';
import {IFileDto, TFileList} from 'shared/types/files';

import {SimpleActionButton} from '../../components';
import {generateUploadFileList, getHandleBeforeUpload, getHandleRemove} from './uploader-list.utils';

import './uploader-list.less';

interface IUploadListProps {
    buttonText?: string;
    fileList?: TFileList[];
    disabled?: boolean;
    onChange?: (fileList: UploadFile<Blob>[]) => void;
    onDownload?: (file: UploadFile<Blob>) => void;
    url?: string;
    dataKeyForDownload?: string;
    classNames?: {
        resetDefaultWrapperClassname?: boolean;
        uploadClassName?: cn.Argument;
        buttonClassName?: cn.Argument;
    };
    styles?: {
        buttonStyle?: CSSProperties;
    };
    dropzoneVariant?: 'dropzone' | 'button';
    isDeleteDisabled?: boolean;
}

export const UploaderList: FC<IUploadListProps> = ({
    fileList = [],
    buttonText = 'Выбрать Файл',
    disabled,
    onChange,
    onDownload,
    url,
    dataKeyForDownload,
    classNames = {},
    styles = {},
    dropzoneVariant = 'button',
    isDeleteDisabled,
}: IUploadListProps) => {
    const handleBeforeUpload = getHandleBeforeUpload(fileList, onChange);
    const handleRemove = getHandleRemove(fileList, onChange);
    const {buttonClassName, uploadClassName, resetDefaultWrapperClassname} = classNames;
    const {buttonStyle} = styles;

    if (!disabled) {
        return (
            <Upload
                className={cn({
                    'upload-list-wrapper': !resetDefaultWrapperClassname,
                    'upload-list-wrapper_with-dropzone': dropzoneVariant === 'dropzone',
                }, uploadClassName)}
                fileList={generateUploadFileList(fileList as IFileDto[], {url, dataKeyForDownload})}
                showUploadList={{
                    showDownloadIcon: true,
                    showRemoveIcon: !isDeleteDisabled,
                    downloadIcon: <LinkIcon />,
                    removeIcon: <CloseIcon />,
                }}
                iconRender={() => (
                    <FileIcon
                        className="file-icon"
                    />
                )}
                onRemove={handleRemove}
                onDownload={onDownload}
                beforeUpload={handleBeforeUpload}
                multiple
            >
                {dropzoneVariant === 'button' ? (
                    <SimpleActionButton
                        style={buttonStyle}
                        className={cn(buttonClassName)}
                        type="primary"
                        title={buttonText}
                    />
                ) : (
                    <div className={cn('upload-list-wrapper__dropzone')}>
                        <div className={cn('upload-list-wrapper__dropzone__icon')}><PlusOutlined /></div>
                        <div>Перетащите файлы или нажмите, чтобы добавить вложение</div>
                    </div>
                )}
            </Upload>
        );
    }
    return (
        <Upload
            className={cn('upload-list-wrapper', uploadClassName)}
            fileList={generateUploadFileList(fileList as IFileDto[])}
            iconRender={() => (
                <FileIcon
                    className="file-icon"
                />
            )}
            showUploadList={{
                showDownloadIcon: true,
                showRemoveIcon: !isDeleteDisabled,
                downloadIcon: <LinkIcon />,
                removeIcon: <CloseIcon />,
            }}
            onRemove={handleRemove}
            onDownload={onDownload}
        />
    );
};
